import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaLock } from "react-icons/fa";
import mascotNoData from "../Assets/icons/okkali_mascot_nodata.png";
import useAuth from "../Hooks/useAuth";
import { resolveLandingPath } from "../utils/landing";

/**
 * 403 — İzinsiz erişim sayfası.
 * RequirePermission izin olmayan route'larda bunu YERİNDE render eder
 * (Navigate zinciri/sonsuz döngü olmaması için yönlendirme yapılmaz).
 * Tasarım, liste boş durumları ve DetailNotFound ile aynı dildedir (maskot + kart).
 */
// Her rolde açık olan sayfa. Ama bu da reddedilebiliyor (ör. panele ait
// olmayan rol) — o yüzden son çare login'dir, yoksa buton hiçbir şey yapmaz.
const SAFE_PATH = "/Anasayfa/Profil";
const LAST_RESORT = "/";

const Page403 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useAuth();

  // "Geri Dön" tek başına yetmiyor: kullanıcı bu sayfaya yönlendirmeyle
  // geldiyse geri gitmek onu yine buraya getirebiliyor. Yetkili ilk sayfaya
  // gideriz; o da mevcut sayfaysa Profil'e (her rolde açık).
  const landing = resolveLandingPath(auth);
  const fallback =
    SAFE_PATH === location.pathname ? LAST_RESORT : SAFE_PATH;
  const target = landing === location.pathname ? fallback : landing;

  return (
    <div className="flex-1 min-h-full flex items-center justify-center p-4 sm:p-8 bg-gray-50/40">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 px-6 py-10 sm:px-12 sm:py-12 max-w-lg w-full text-center">
        <img
          src={mascotNoData}
          alt="Erişim yetkisi yok"
          className="w-32 h-32 sm:w-40 sm:h-40 object-contain mx-auto mb-5 drop-shadow-lg select-none"
          draggable={false}
        />
        <div className="inline-flex items-center gap-2 px-3 py-1 mb-3 rounded-full bg-red-50 border border-red-200 text-red-700 text-xs font-semibold">
          <FaLock className="w-3 h-3" />
          403 — Erişim Yetkisi Yok
        </div>
        <h1 className="text-lg sm:text-xl font-bold text-gray-800 mb-2">
          Bu sayfayı görüntüleme yetkiniz bulunmuyor
        </h1>
        <p className="text-sm sm:text-base text-gray-500 mb-6">
          Bu alana erişmeniz gerektiğini düşünüyorsanız yöneticinizle iletişime
          geçin. Yetkiler, firmanızın Kullanıcı Şablonları üzerinden yönetilir.
        </p>
        <button
          type="button"
          onClick={() => navigate(target, { replace: true })}
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors text-sm font-medium"
        >
          <FaArrowLeft className="w-3.5 h-3.5" />
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};

export default Page403;
